"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Documentation;

var React = _interopRequireWildcard(require("react"));

var _react2 = require("linaria/react");

var _Content = _interopRequireDefault(require("./Content"));

var _Markdown = _interopRequireDefault(require("./Markdown"));

var _EditButton = _interopRequireDefault(require("./EditButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Title =
/*#__PURE__*/
(0, _react2.styled)("h1")({
  name: "Title",
  class: "Title_t1dytcq5"
});
const MarkdownContent =
/*#__PURE__*/
(0, _react2.styled)(_Markdown.default)({
  name: "MarkdownContent",
  class: "MarkdownContent_m3ctz2y"
});
const PropInfo =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "PropInfo",
  class: "PropInfo_p1eats2g"
});
const PropLabel =
/*#__PURE__*/
(0, _react2.styled)("a")({
  name: "PropLabel",
  class: "PropLabel_psi127e"
});
const PropItem =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "PropItem",
  class: "PropItem_pwdtv5j"
});
const RestPropsLabel =
/*#__PURE__*/
(0, _react2.styled)("a")({
  name: "RestPropsLabel",
  class: "RestPropsLabel_r5pwgte"
});
const REACT_STATIC_METHODS = ['getDerivedStateFromProps'];
const ANNOTATION_OPTIONAL = '@optional';
const ANNOTATION_INTERNAL = '@internal';
const ANNOTATION_EXTENDS = '@extends';

const getTypeName = type => type.raw || type.name || '';

const hasAnnotation = (item, annotation) => // eslint-disable-next-line no-nested-ternary
item.description ? item.description.startsWith(annotation) : item.docblock ? item.docblock.startsWith(annotation) : false;

const pascalToCamelCase = text => text.replace(/^[A-Z]+/g, $1 => $1.toLowerCase());

const PropTypeDoc = ({
  name,
  description,
  flowType,
  tsType,
  type,
  required,
  defaultValue
}) => {
  const isRequired = required && defaultValue == null && !description.startsWith(ANNOTATION_OPTIONAL);
  const typeName = // eslint-disable-next-line no-nested-ternary
  flowType ? getTypeName(flowType) : tsType ? getTypeName(tsType) : type ? getTypeName(type) : null;
  return React.createElement(PropInfo, null, React.createElement(PropLabel, {
    name: name,
    href: `#${name}`
  }, React.createElement("code", null, name), isRequired ? ' (required)' : ''), typeName && typeName !== 'unknown' ? React.createElement(PropItem, null, React.createElement("span", null, "Type: "), React.createElement("code", null, typeName)) : null, defaultValue ? React.createElement(PropItem, null, React.createElement("span", null, "Default value: "), React.createElement("code", null, defaultValue.value)) : null, description ? React.createElement(PropItem, {
    as: MarkdownContent,
    source: description.replace(/^@optional/, '').trim()
  }) : null);
};

const MethodDoc = ({
  name,
  description,
  type,
  params,
  returns
}) => {
  const typeName = type ? getTypeName(type) : null;
  return React.createElement(PropInfo, {
    key: name
  }, React.createElement(PropLabel, {
    name: name,
    href: `#${name}`
  }, React.createElement("code", null, name)), typeName && typeName !== 'unknown' ? React.createElement(PropItem, null, React.createElement("span", null, "Type: "), React.createElement("code", null, typeName)) : null, params.length ? React.createElement(PropItem, null, React.createElement("span", null, "Params: "), React.createElement("code", null, params.map(p => `${p.name}${p.type ? `: ${getTypeName(p.type)}` : ''}`).join(', '))) : null, returns && returns.type ? React.createElement(PropItem, null, React.createElement("span", null, "Returns: "), React.createElement("code", null, getTypeName(returns.type))) : null, description ? React.createElement(PropItem, {
    as: MarkdownContent,
    source: description.trim()
  }) : null);
};

const PropertyDoc = ({
  name,
  description,
  type,
  value,
  link
}) => {
  const typeName = type ? getTypeName(type) : null;
  return React.createElement(PropInfo, null, React.createElement(PropLabel, {
    name: name,
    href: `${typeName === 'static' && link ? `${link}` : `#${name}`}`
  }, React.createElement("code", null, name)), typeName && typeName !== 'unknown' ? React.createElement(PropItem, null, React.createElement("span", null, "Type: "), React.createElement("code", null, typeName)) : null, typeof value === 'string' || typeof value === 'number' ? React.createElement(PropItem, null, React.createElement("span", null, "Value: "), React.createElement("code", null, value)) : null, description ? React.createElement(PropItem, {
    as: MarkdownContent,
    source: description.replace(/^@optional/, '').trim()
  }) : null);
};

function Documentation({
  name,
  info,
  logo,
  github,
  filepath
}) {
  const restProps = [];
  const description = info.description.split('\n').filter(line => {
    if (line.startsWith(ANNOTATION_EXTENDS)) {
      const parts = line.split(' ').slice(1);
      const link = parts.pop();
      restProps.push({
        name: parts.join(' '),
        link
      });
      return false;
    }

    return true;
  }).join('\n');
  const props = info.props || {};
  const keys = Object.keys(props).filter(prop => !hasAnnotation(props[prop], ANNOTATION_INTERNAL));
  const methods = info.methods.filter(method => !(method.name.startsWith('_') || method.modifiers.includes('static') || method.docblock == null || hasAnnotation(method, ANNOTATION_INTERNAL)));
  const statics = info.statics.map(prop => ({
    type: 'property',
    info: prop
  })).concat(info.methods.filter(method => method.modifiers.includes('static') && method.docblock != null && !REACT_STATIC_METHODS.includes(method.name)).map(method => ({
    type: 'method',
    info: _objectSpread({}, method, {
      type: {
        raw: 'Function'
      }
    })
  }))).filter(item => !(item.info.name.startsWith('_') || hasAnnotation(item.info, ANNOTATION_INTERNAL)));
  return React.createElement(_Content.default, {
    logo: logo
  }, React.createElement(Title, null, name), React.createElement(MarkdownContent, {
    source: description,
    options: {
      linkify: true
    }
  }), keys.length || restProps.length ? React.createElement(React.Fragment, null, React.createElement("h2", null, "Props"), keys.map(prop => React.createElement(PropTypeDoc, _extends({
    key: prop,
    name: prop
  }, props[prop]))), restProps.map(prop => React.createElement(RestPropsLabel, {
    key: prop.name,
    href: prop.link
  }, React.createElement("code", null, "...", prop.name)))) : null, methods.length ? React.createElement(React.Fragment, null, React.createElement("h2", null, "Methods"), React.createElement("p", null, "These methods can be accessed on the ", React.createElement("code", null, "ref"), " of the component, e.g.", ' ', React.createElement("code", null, pascalToCamelCase(name), "Ref.", methods[0].name, "(...args)"), "."), methods.map(method => React.createElement(MethodDoc, _extends({
    key: method.name,
    type: null
  }, method)))) : null, statics.length ? React.createElement(React.Fragment, null, React.createElement("h2", null, "Static properties"), React.createElement("p", null, "These properties can be accessed on ", React.createElement("code", null, name), " by using the dot notation, e.g.", ' ', React.createElement("code", null, name, ".", statics[0].info.name), "."), statics.map(s => {
    if (s.type === 'method') {
      return React.createElement(MethodDoc, _extends({
        key: s.info.name
      }, s.info));
    }

    return React.createElement(PropertyDoc, _extends({
      key: s.info.name
    }, s.info));
  })) : null, React.createElement(_EditButton.default, {
    github: github,
    filepath: filepath
  }));
}
//# sourceMappingURL=Documentation.js.map

require('../css/src/templates/Documentation.css');
